export const KEY_MAP_DOCS = [
  {
    sequences: ['c'],
    description: 'Copy shareable link to clipboard',
  },
  {
    sequences: ['m'],
    description: 'Toggle masked mode',
  },
  {
    sequences: ['o', 'cmd+k', 'ctrl+k'],
    description: 'Omnibar',
  },
];
